import React from "react";
import { Container } from "reactstrap";
import Slide from "../../components/user/Carousel";
import Collection from "../../components/user/Collection";
import Image from "../../components/user/Image";
import Testimonials from "../../components/user/Testimonials";
import Ship from "../../components/user/Ship";
import Newsletter from "../../components/user/Newsletter";
import Footer from "../../components/user/Footer";
import "swiper/css/bundle";

function Home() {
  return (
    <div>
      <Slide />

      <Container>
        <Collection />
        <Testimonials />
        <Image />
        <Ship />
        <Newsletter />
      </Container>

      <Footer />
    </div>
  );
}

export default Home;
